// @flow
import React, { Component }  from "react";
import logo from "./images/img.png";
import "./styles.css";


class Header  extends Component<{}>{
  componentDidMount() {
    // When the header mounts, scroll to the top of the page
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Remove for instant scroll
    });
  }

  render() {
    return (
      <div>
          <header id="masthead" className="site-header" role="banner">
            <div className="main-menu-wrapper">
              <div className="main-resposive-menu">
                <div id="logo" className="logo">
                  <a href="https://www.ski-lifts.com/" rel="home">
                    <img src={logo}
                         alt="airport transfers to ski resorts" width="" height="55"/>
                  </a>
                </div>
              </div> 
            </div>
          </header>
       
      </div>
    );
  }
}



export default Header;
